import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserIdleLockService {
  private readonly activityEvents: Array<keyof DocumentEventMap> = [
    'keydown',
    'pointerdown',
    'mousemove',
    'scroll',
    'touchstart'
  ];

  private intervalId: number | null = null;
  private lastActivityAt = Date.now();
  private thresholdMs = 15 * 60 * 1000;
  private triggered = false;
  private onIdle: (() => void) | null = null;

  private readonly activityHandler = () => this.markActivity();
  private readonly visibilityHandler = () => {
    if (document.visibilityState === 'visible') {
      this.check();
    }
  };

  start(minutes: number, onIdle: () => void): void {
    this.stop();

    const normalizedMinutes = Math.min(240, Math.max(1, minutes));
    this.thresholdMs = normalizedMinutes * 60 * 1000;
    this.lastActivityAt = Date.now();
    this.triggered = false;
    this.onIdle = onIdle;

    for (const eventName of this.activityEvents) {
      document.addEventListener(
        eventName,
        this.activityHandler,
        { passive: true }
      );
    }

    document.addEventListener(
      'visibilitychange',
      this.visibilityHandler
    );

    this.intervalId = window.setInterval(
      () => this.check(),
      Math.min(30_000, Math.max(5_000, this.thresholdMs / 4))
    );
  }

  stop(): void {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }

    for (const eventName of this.activityEvents) {
      document.removeEventListener(
        eventName,
        this.activityHandler
      );
    }

    document.removeEventListener(
      'visibilitychange',
      this.visibilityHandler
    );

    this.onIdle = null;
    this.triggered = false;
  }

  private markActivity(): void {
    if (this.triggered) {
      return;
    }

    this.lastActivityAt = Date.now();
  }

  private check(): void {
    if (
      this.triggered ||
      !this.onIdle ||
      Date.now() - this.lastActivityAt < this.thresholdMs
    ) {
      return;
    }

    this.triggered = true;
    const callback = this.onIdle;
    this.stop();
    callback();
  }
}
